/**
 * Engine router — pick the right TtsEngine for a model entry.
 */

import { ModelEntry } from '../modelRegistry';
import { TtsEngine } from './types';
import { webSpeechEngine } from './webSpeech';
import { piperEngine } from './piper';
import { kokoroEngine } from './kokoro';
import { chatterboxEngine } from './chatterbox';
import { vieneuEngine } from './vieneu';

export function getEngineForModel(model: ModelEntry): TtsEngine {
  switch (model.engine) {
    case 'webspeech':
      return webSpeechEngine;
    case 'piper':
      return piperEngine;
    case 'kokoro':
      return kokoroEngine;
    case 'chatterbox':
      return chatterboxEngine;
    case 'vieneu':
      return vieneuEngine;
    default:
      return webSpeechEngine;
  }
}

export { webSpeechEngine, piperEngine, kokoroEngine, chatterboxEngine, vieneuEngine };
